import { apiClient } from 'utils/ApiClient';
import { Logger } from 'utils/Logger';
import { Playlist, PlaylistUpsertPayload } from './Playlists.types';

const LOG_PREFIX = 'BeamOnScreen/playlists/Playlists.api';

export const playlistsApi = {
    list: async (search = ''): Promise<Playlist[]> => {
        try {
            const qs = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
            const response = await apiClient.get<Playlist[]>(`/bos/playlists${qs}`);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            Logger.error(LOG_PREFIX, `list failed: ${error}`);
            throw error;
        }
    },
    get: async (playlistId: string): Promise<Playlist> => {
        const response = await apiClient.get<Playlist>(`/bos/playlists/${encodeURIComponent(playlistId)}`);
        return response.data!;
    },
    create: async (payload: PlaylistUpsertPayload): Promise<Playlist> => {
        try {
            const response = await apiClient.post<Playlist>('/bos/playlists', payload);
            return response.data!;
        } catch (error) {
            Logger.error(LOG_PREFIX, `create failed: ${error}`);
            throw error;
        }
    },
    update: async (playlistId: string, payload: PlaylistUpsertPayload): Promise<Playlist> => {
        try {
            const response = await apiClient.put<Playlist>(`/bos/playlists/${encodeURIComponent(playlistId)}`, payload);
            return response.data!;
        } catch (error) {
            Logger.error(LOG_PREFIX, `update(${playlistId}) failed: ${error}`);
            throw error;
        }
    },
    remove: async (playlistId: string): Promise<{ screensUnassigned: number }> => {
        const response = await apiClient.delete<{ screensUnassigned: number }>(`/bos/playlists/${encodeURIComponent(playlistId)}`);
        return response.data ?? { screensUnassigned: 0 };
    },
};
